import { useEffect, useReducer, useState } from "react"
import { useHistory } from "react-router"
import ReactECharts from 'echarts-for-react';
import { LinearProgress, Paper, Typography, withStyles } from "@material-ui/core";
import StarOn from '../assets/starOn.png';
import StarOff from '../assets/starOff.png';
import api from "./api";

const BorderLinearProgress = withStyles((theme) => ({
    root: {
        height: 20,
        borderRadius: 10,
    },
    colorPrimary: {
        backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
    },
    bar: {
        borderRadius: 10,
        backgroundColor: '#49ea6e',
    },
}))(LinearProgress);

const BorderLinearProgressKiosk = withStyles((theme) => ({
    root: {
        height: 20,
        borderRadius: 10,
    },
    colorPrimary: {
        backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
    },
    bar: {
        borderRadius: 10,
        backgroundColor: "#3aecb1",
    },
}))(LinearProgress);

const Rating = withStyles((theme) => ({
    root: {
        height: 20,
        borderRadius: 10,
    },
    colorPrimary: {
        backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
    },
    bar: {
        borderRadius: 10,
        backgroundColor: "#49ea6e",
    },
}))(LinearProgress);

export default function DashboardReview(props) {
    const history = useHistory()

    const [option, setOption] = useState(null)

    const [waitingTime, setWaitingTime] = useState(0)
    const [serviceTime, setServiceTime] = useState(0)
    const [rating, setRating] = useState(0)
    const [roundRating, setRoundRating] = useState(0)
    const [dataRating, setDataRating] = useState(0)
    const [totalRating, setTotalRating] = useState(0)
    const [totalAkun, setTotalAkun] = useState(0)
    const [loading, setLoading] = useState(false)

    const forceUpdate = useReducer(bool => !bool)[1];

    useEffect(() => {
        getData()
    }, [])

    const getData = () => {
        api.create().getDashboardReview(props.month.id, props.year.nama).then(response => {
            console.log(response);
            if (response.data) {
                let data = response.data
                setWaitingTime(data.doctor_queue.average_patient_waiting_time)
                setServiceTime(data.doctor_queue.average_doctor_service_time)
                setRating(data.average_rating)
                setRoundRating(Number(data.average_rating).toFixed())
                setTotalRating(data.total_rating)
                setTotalAkun(data.total_account)
                setDataRating(data.rating)
                let fasilitas = []
                let waitingFasilitas = []
                let serviceFasilitas = []
                response.data.another_facilities_queue.map((item) => {
                    fasilitas.push(item.facility)
                    waitingFasilitas.push(item.average_patient_waiting_time)
                    serviceFasilitas.push(item.average_doctor_service_time)
                })

                let dataFasilitas = {
                    title: {
                        text: 'Antrian Fasilitas Lainnya',
                        subtext: '',
                        textStyle: {
                            color: '#2a9c6c', fontSize: 22, fontFamily: 'Poppins', fontWeight: '500'
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    legend: {
                        bottom: 0,
                        // data: ['2011年', '2012年']
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '10%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'value',
                        boundaryGap: [0, 0.01]
                    },
                    yAxis: {
                        type: 'category',
                        data: fasilitas
                    },
                    series: [
                        {
                            name: 'Rata-rata Waktu tunggu',
                            type: 'bar',
                            color: '#49ea6e',
                            data: waitingFasilitas,
                            // backgroundStyle: {
                            borderRadius: 20
                            // }
                        },
                        {
                            name: 'Rata-rata Waktu pelayanan',
                            type: 'bar',
                            color: '#3aecb1',
                            data: serviceFasilitas
                        }
                    ]
                };
                setOption(dataFasilitas)
                setLoading(true)
                forceUpdate()
            }
        })
    }

    return (
        <div style={{ maxHeight: props.height - 140, display: 'grid', overflow: 'scroll', margin: '20px 0px 0px 0px' }}>
            {loading && (
                <div style={{ margin: '5px 0px', paddingLeft: 20, paddingRight: 20, width: '100%', display: 'flex', justifyContent: 'space-between', }}>
                    <div style={{ width: '73%' }}>
                        <Paper style={{ height: 220, width: '100%', borderRadius: 20, boxShadow: '8px 8px 16px 0 rgba(55, 55, 55, 0.2)' }} >
                            <div style={{ paddingLeft: 20, paddingTop: 10 }}>
                                <Typography style={{ color: '#2a9c6c', fontSize: 22, fontFamily: 'Poppins', fontWeight: '500' }}>Antrian Dokter</Typography>
                            </div>
                            <div style={{ padding: '20px 25px 0px 25px' }}>
                                <BorderLinearProgress variant="determinate" value={waitingTime} />
                            </div>
                            <div style={{ padding: '20px 25px' }}>
                                <BorderLinearProgressKiosk variant="determinate" value={serviceTime} />
                            </div>
                            <div style={{ padding: '10px 20px' }}>
                                <div style={{ marginRight: 30 }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <div style={{ backgroundColor: '#49ea6e', width: 40, height: 15, borderRadius: 10, marginRight: 20 }} />
                                        <Typography style={{ color: '#acacac', fontSize: 16 }}>Rata-rata waktu tunggu antrian pasien (Menit)</Typography>
                                    </div>
                                </div>
                                <div style={{ marginRight: 30 }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <div style={{ backgroundColor: "#3aecb1", width: 40, height: 15, borderRadius: 10, marginRight: 20 }} />
                                        <Typography style={{ color: '#acacac', fontSize: 16 }}>Rata-rata waktu pelayanan dokter (Menit)</Typography>
                                    </div>
                                </div>
                            </div>
                        </Paper>
                        <Paper style={{ width: '100%', borderRadius: 20, boxShadow: '8px 8px 16px 0 rgba(55, 55, 55, 0.2)', marginTop: 10, padding: '5px 20px' }}>
                            <ReactECharts
                                style={{ height: 486, width: '99%', marginTop: 20 }}
                                option={option}
                            />
                        </Paper>
                    </div>
                    <div style={{ width: '25%', }}>
                        <Paper style={{ width: '100%', borderRadius: 20, boxShadow: '8px 8px 16px 0 rgba(55, 55, 55, 0.2)', margin: 5, padding: '1%', padding: 20, overflow: 'scroll' }}>
                            <div>
                                <Typography style={{ color: '#2a9c6c', fontSize: 22, fontFamily: 'Poppins', fontWeight: '500'}}>Review Pasien</Typography>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
                                <Typography style={{ color: '#000000', fontSize: 100, fontFamily: 'Poppins', fontWeight: 'bold' }}>{rating}</Typography>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: 15 }}>
                                <img src={roundRating >= 1 ? StarOn : StarOff} style={{ width: 30 }} />
                                <img src={roundRating >= 2 ? StarOn : StarOff} style={{ width: 30 }} />
                                <img src={roundRating >= 3 ? StarOn : StarOff} style={{ width: 30 }} />
                                <img src={roundRating >= 4 ? StarOn : StarOff} style={{ width: 30 }} />
                                <img src={roundRating >= 5 ? StarOn : StarOff} style={{ width: 30 }} />
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 30, width: '100%' }}>
                                <div style={{ display: 'flex', width: '55%', justifyContent: 'space-between' }}>
                                    <Typography style={{ color: '#000000', fontSize: 20, fontFamily: 'Poppins', fontWeight: '500' }}>Total Rating</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 20, fontFamily: 'Poppins', fontWeight: '500' }}>{totalRating}</Typography>
                                </div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 5, width: '100%' }}>
                                <div style={{ display: 'flex', width: '55%', justifyContent: 'space-between' }}>
                                    <Typography style={{ color: '#000000', fontSize: 20, fontFamily: 'Poppins', fontWeight: '500' }}>Total Akun</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 20, fontFamily: 'Poppins', fontWeight: '500' }}>{totalAkun}</Typography>
                                </div>
                            </div>
                            {dataRating.length > 0 && dataRating.map((item, index) => {
                                return (
                                    <div style={{ marginTop: index === 0 ? 30 : 20, width: '100%' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <Typography style={{ color: '#333333', fontSize: 18, fontFamily: 'Poppins', fontWeight: '500' }}>{item.title}</Typography>
                                            <Typography style={{ color: '#979797', fontSize: 18, fontFamily: 'Poppins', fontWeight: '500' }}>{item.percentage}%</Typography>
                                        </div>
                                        <div style={{ width: '100%', marginTop: 5 }}>
                                            <Rating variant="determinate" value={item.percentage} />
                                        </div>
                                    </div>
                                )
                            })}
                            {/* <div style={{ marginTop: 20, width: '100%' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography style={{ color: '#333333', fontSize: 18, fontFamily: 'Poppins', fontWeight: '500' }}>Rating 4</Typography>
                                    <Typography style={{ color: '#979797', fontSize: 18, fontFamily: 'Poppins', fontWeight: '500' }}>80%</Typography>
                                </div>
                                <div style={{ width: '100%', marginTop: 5 }}>
                                    <Rating variant="determinate" value={80} />
                                </div>
                            </div>
                            <div style={{ marginTop: 20, width: '100%' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography style={{ color: '#333333', fontSize: 18, fontFamily: 'Poppins', fontWeight: '500' }}>Rating 3</Typography>
                                    <Typography style={{ color: '#979797', fontSize: 18, fontFamily: 'Poppins', fontWeight: '500' }}>30%</Typography>
                                </div>
                                <div style={{ width: '100%', marginTop: 5 }}>
                                    <Rating variant="determinate" value={30} />
                                </div>
                            </div>
                            <div style={{ marginTop: 20, width: '100%' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography style={{ color: '#333333', fontSize: 18, fontFamily: 'Poppins', fontWeight: '500' }}>Rating 2</Typography>
                                    <Typography style={{ color: '#979797', fontSize: 18, fontFamily: 'Poppins', fontWeight: '500' }}>5%</Typography>
                                </div>
                                <div style={{ width: '100%', marginTop: 5 }}>
                                    <Rating variant="determinate" value={5} />
                                </div>
                            </div>
                            <div style={{ marginTop: 20, width: '100%' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography style={{ color: '#333333', fontSize: 18, fontFamily: 'Poppins', fontWeight: '500' }}>Rating 1</Typography>
                                    <Typography style={{ color: '#979797', fontSize: 18, fontFamily: 'Poppins', fontWeight: '500' }}>2%</Typography>
                                </div>
                                <div style={{ width: '100%', marginTop: 5 }}>
                                    <Rating variant="determinate" value={2} />
                                </div>
                            </div> */}
                        </Paper>
                    </div>
                </div>
            )}
        </div>
    )
}